import { useState } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "features/components/IconButton";
import CheckIcon from "features/ui/Icons/CheckIcon";
import CopyIcon from "features/ui/Icons/CopyIcon";

import { copyShareURL } from "./utils";

interface Props {
  url: string;
}

const ShareLinkToast = ({ url }: Props) => {
  const { t } = useTranslation();
  const [hasCopied, setHasCopied] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);

  const handleCopy = async () => {
    const copied = await copyShareURL(url);

    setHasCopied(copied);
    setHasFailed(!copied);
  };

  return (
    <div className="flex flex-col gap-1">
      <span>{t("duck:share_thread_copy_failed")}</span>

      <div className="flex items-center gap-2">
        <span className="text-xs break-all select-all">{url}</span>
        <IconButton
          onClick={handleCopy}
          size="small"
          color="inherit"
          data-testid="duck-share-link-copy"
          tooltip={
            hasCopied
              ? t("common:copy_url.success")
              : t("common:copy_url.tooltip")
          }
        >
          {hasCopied ? (
            <CheckIcon fontSize="small" />
          ) : (
            <CopyIcon fontSize="small" />
          )}
        </IconButton>
      </div>

      {hasFailed && (
        <span className="text-xs">{t("common:copy_url.error")}</span>
      )}
    </div>
  );
};

export default ShareLinkToast;
